import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ICU from "i18next-icu";
import { Tolgee, I18nextPlugin, withTolgee, BackendFetch } from "@tolgee/i18next";

export const i18nContainer = {
  init() {
    const tolgee = Tolgee()
      .use(BackendFetch())
      .use(I18nextPlugin())
      .init({
        apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
        apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,
        projectId: import.meta.env.VITE_APP_TOLGEE_PROJECT_ID,
        ns: ["translation"],
        defaultNs: "translation"
      });

    withTolgee(i18n, tolgee)
      .use(ICU)
      .use(initReactI18next)
      .init({
        lng: "en",
        fallbackLng: "en",
        debug: true,
        interpolation: {
          escapeValue: false
        },
        keySeparator: ".",
        react: {
          bindI18n: "languageChanged"
        }
      });
  }
};

export default i18n;
